import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'
import { clearLocalStorage } from '../../helper/storage'
import { axiosInstance } from '../../axios/interceptor'

export const getAllSchedules = createAsyncThunk('schedule/all', async (params, { rejectWithValue }) => {
  try {
    const response = await axiosInstance.get(`/property-schedule/get-all-property-schedule`, { params })
    return response
  } catch (error) {
    return rejectWithValue(error)
  }
})

export const getSchedulesPropertyBydate = createAsyncThunk('schedule/property/get', async (params, { rejectWithValue }) => {
  try {
    const response = await axiosInstance.get(`/property-schedule/get-all-property-schedule-details`, { params })
    return response
  } catch (error) {
    return rejectWithValue(error)
  }
})

export const getAllRegions = createAsyncThunk('schedule/region/get', async (params, { rejectWithValue }) => {
  try {
    const response = await axiosInstance.get(`/admin/region/get-all-region`)
    return response
  } catch (error) {
    return rejectWithValue(error)
  }
})

export const getGoogleMapUrl = createAsyncThunk('schedule/google-map-url/get', async (id, { rejectWithValue }) => {
  try {
    const response = await axiosInstance.get(`/get-google-map-url/${id}`)
    return response
  } catch (error) {
    return rejectWithValue(error)
  }
})

const initialState = {
  isLoading: false,
  allSchedules: [],
  scheduleProperty: [],
  allRegions: [],
  error: null
}

const scheduleSlice = createSlice({
  name: 'schedule',
  initialState,
  reducers: {
    resetAuthState: (state) => {
      state.user = null
      clearLocalStorage()
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(getAllSchedules.pending, (state) => {
        state.isLoading = true
        state.allSchedules = []
      })
      .addCase(getAllSchedules.fulfilled, (state, action) => {
        state.isLoading = false
        state.allSchedules = action.payload?.data?.data
      })
      .addCase(getAllSchedules.rejected, (state, action) => {
        state.isLoading = false
        state.error = action.error.message
      })
      .addCase(getSchedulesPropertyBydate.pending, (state) => {
        state.isLoading = true
        state.scheduleProperty = []
      })
      .addCase(getSchedulesPropertyBydate.fulfilled, (state, action) => {
        state.isLoading = false
        state.scheduleProperty = action.payload?.data?.data
      })
      .addCase(getSchedulesPropertyBydate.rejected, (state, action) => {
        state.isLoading = false
        state.error = action.error.message
        state.scheduleProperty = []
      })
      .addCase(getAllRegions.pending, (state) => {
        state.isLoading = true
      })
      .addCase(getAllRegions.fulfilled, (state, action) => {
        state.isLoading = false
        state.allRegions = action.payload?.data?.data
      })
      .addCase(getAllRegions.rejected, (state, action) => {
        state.isLoading = false
        state.error = action.error.message
        state.allRegions = []
      })
      .addCase(getGoogleMapUrl.pending, (state) => {
        state.isLoading = true
      })
      .addCase(getGoogleMapUrl.fulfilled, (state) => {
        state.isLoading = false
      })
      .addCase(getGoogleMapUrl.rejected, (state, action) => {
        state.isLoading = false
        state.error = action.error.message
      })

  }
})

export const { resetAuthState } = scheduleSlice.actions
export default scheduleSlice.reducer
